const pageTitleSuffix = '| Loom'

export const addTitleSuffix = (title: string) => `${title} ${pageTitleSuffix}`

export const PAGE_TITLES = {
  HOME: addTitleSuffix('Home'),
  TYPING_PROGRAM: addTitleSuffix('Typing Program'),
  TYPED_LOTS: addTitleSuffix('Typed Lots'),
  WOOL_STORE_TOOLS: addTitleSuffix('Wool Store Tools'),
  WOOL_SPECIFICATIONS: addTitleSuffix('Wool Specifications'),
  STATION_SEARCH: addTitleSuffix('Station Search'),
  OFFERS: addTitleSuffix('Offers'),
  LOGGED_OUT: addTitleSuffix('Logged Out'),
  Admin: addTitleSuffix('Admin'),
}
